<template>
  <div class="d-flex align-center my-2">
    <v-textarea
      @keydown.enter.prevent="submit"
      hide-details
      outlined
      auto-grow
      clearable
      dense
      :label="$t('journal.search.criterias.keywords.input')"
      rows="1"
      v-model="text"
      :rules="rules"
    />
    <v-text-field
      @keydown.enter.prevent="submit"
      :label="$t('journal.search.criterias.score')"
      style="width: 150px; max-width: 150px;"
      class="ml-2 col-3"
      hide-details
      dense
      outlined
      type="number"
      v-model="multiplier"
      :rules="rules"
    />
  </div>
</template>
<script>
import { nanoid } from 'nanoid';
import { criterias } from '../SearchCriteria';

export default {
  name: 'KeywordScore',
  props: {
    params: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    text: '',
    multiplier: 0.5,
    include: true,
    id: `${criterias.KEYWORD_SCORE}/${nanoid(10)}`,
    rules: [
      v => !!v || 'Ce champs ne peut être vide',
    ],
  }),
  created() {
    if (this.params !== undefined) {
      const data = this.params.scorings[0].Keywords;
      this.id = data.id;
      this.text = data.param;
      this.multiplier = Number.parseFloat(data.multiplier);
    }
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
    getCriteria() {
      return {
        scorings: [
          {
            Keywords: {
              param: this.text,
              multiplier: Number.parseFloat(this.multiplier),
              id: this.id,
            },
          },
        ],
      };
    },
  },
};
</script>
